﻿import {CreateOrSelectDriverModel} from "../components/CreateOrSelectDriverComponent";
import {CreateOrSelectResidencyModel} from "../components/CreateOrSelectResidencyComponent";
import {CreateOrSelectVehicleModel} from "../components/CreateOrSelectVehicleComponent";
import {Drivers} from "../Drivers";
import {DriverType} from "../enums/DriverType";
import IHolder from "../interfaces/IHolder";
import {Residencies} from "../Residencies";
import {DriverResult} from "../types/DriverResult";
import {ResidencyResult} from "../types/ResidencyResult";
import {VehicleResult} from "../types/VehicleResult";
import {Vehicles} from "../Vehicles";


export function toResidencyResult(residency: CreateOrSelectResidencyModel, holder: IHolder): ResidencyResult {
	return residency.residencyId === "create" ? {
		id: null!,
		address: residency.arguments.address,
		suffix: residency.arguments.suffix,
		uses: residency.arguments.uses,
		zoneId: residency.arguments.zoneId,
		attachments: [],
		customData: []
	} : Residencies.get(holder, residency.residencyId);
}

export function toDriverResult(driver: CreateOrSelectDriverModel, holder: IHolder): DriverResult {
	return driver.driverId === "create"
		? {
			id: null!,
			type: DriverType.None,
			fullName: driver.arguments.fullName,
			licenseNumber: driver.arguments.licenseNumber,
			attachments: [],
			customData: []
		}
		: Drivers.get(holder, driver.driverId);
}

function toVehicleResult(vehicle: CreateOrSelectVehicleModel, holder: IHolder): VehicleResult {
	return vehicle.vehicleId === "create"
		? {
			id: null!,
			plate: vehicle.arguments.plate,
			data: vehicle.arguments.data,
			type: vehicle.arguments.type,
			hidden: false,
			attachments: [],
			customData: []
		}
		: Vehicles.get(holder, vehicle.vehicleId)
}

export function toVehicleResults(vehicleGroups: CreateOrSelectVehicleModel[][], holder: IHolder): VehicleResult[][] {
	return vehicleGroups.map(vehicles => vehicles.map(vehicle => toVehicleResult(vehicle, holder)));
}

export function vehicleResultToPlates(vehicleGroups: VehicleResult[][]): string[][] {
	return vehicleGroups.map(vehicles => vehicles.map(vehicle => vehicle.plate));
}
